/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iconik_Publish_Failed_ToastInputs */

const en_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project failed to publish with error: ${i?.error}`)
};

const fr_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de publication du projet : ${i?.error}`)
};

const de_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Projekt konnte mit folgendem Fehler nicht veröffentlicht werden: ${i?.error}`)
};

const it_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La pubblicazione del progetto non è riuscita a causa dell'errore: ${i?.error}`)
};

const ru_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Проект не был опубликован с ошибкой: ${i?.error}`)
};

const es_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El proyecto no se pudo publicar con el error: ${i?.error}`)
};

const zh_cn2_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目发布失败，错误信息：${i?.error}`)
};

const ja_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトの公開に失敗しました。エラー: ${i?.error}`)
};

const hi_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट ${i?.error} त्रुटि के साथ प्रकाशित होने में विफल रहा।`)
};

const pt_pt2_iconik_publish_failed_toast = /** @type {(inputs: Iconik_Publish_Failed_ToastInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O projeto não pôde ser publicado devido ao erro: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Project failed to publish with error: {error}" |
*
* @param {Iconik_Publish_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_failed_toast = /** @type {((inputs: Iconik_Publish_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_failed_toast(inputs)
	if (locale === "de") return de_iconik_publish_failed_toast(inputs)
	if (locale === "it") return it_iconik_publish_failed_toast(inputs)
	if (locale === "ru") return ru_iconik_publish_failed_toast(inputs)
	if (locale === "es") return es_iconik_publish_failed_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_failed_toast(inputs)
	if (locale === "ja") return ja_iconik_publish_failed_toast(inputs)
	if (locale === "hi") return hi_iconik_publish_failed_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_failed_toast(inputs)
	return en_iconik_publish_failed_toast(inputs)
});